import { render } from "./Avis.vue?vue&type=template&id=1b2fd21a&scoped=true"
import script from "./Avis.vue?vue&type=script&lang=js"
export * from "./Avis.vue?vue&type=script&lang=js"

import "./Avis.vue?vue&type=style&index=0&id=1b2fd21a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2fd21a"]])

export default __exports__